import { useState, useEffect } from 'react';
import { windowUtils } from 'utils/window';

export function useIsMobile(query = '(max-width: 500px)') {
  const [isMobile, setIsMobile] = useState(() => {
    return windowUtils.getSafeWindow()?.matchMedia(query).matches ?? false;
  });

  useEffect(() => {
    const mediaQueryList = windowUtils.getSafeWindow()?.matchMedia(query);
    if (mediaQueryList) {
      const listener = (event: MediaQueryListEvent) => setIsMobile(event.matches);
      mediaQueryList.addEventListener('change', listener);
      return () => mediaQueryList.removeEventListener('change', listener);
    }
  }, [query]);

  return isMobile;
}
